export interface VoucherDetalle {
  idVoucherDetalle: number;
  idVoucher: number;
  numeroLinea: number;
  codigoCuenta: string;
  idPlanCuenta: number | null;
  debeMN: number;
  haberMN: number;
  debeME: number;
  haberME: number;
  codigoAuxiliar: string | null;
  tipoAuxiliar: string | null;
  glosaDetalle: string | null;
  codigoCentroCosto: string | null;
  codigoArea: string | null;
  planCuenta?: { descripcion: string } | null;
}

export interface Voucher {
  idVoucher: number;
  numeroRegistro: string;
  idEjercicio: number;
  idPeriodo: number;
  codigoFuente: string;
  fechaMovimiento: string;
  fechaDocumento: string | null;
  tipoDocumento: string | null;
  serieDocumento: string | null;
  numeroDocumento: string | null;
  glosa: string;
  monedaOrigen: string;
  tipoCambio: number;
  codigoCentroCosto: string | null;
  codigoSubCentroCosto: string | null;
  controlMoneda: string | null;
  tipoAfectacion: string | null;
  estado: string;
  totalDebeMN: number;
  totalHaberMN: number;
  totalDebeME: number;
  totalHaberME: number;
  idUsuarioCreacion: number | null;
  fechaCreacion: string;
  detalles: VoucherDetalle[];
}

export const FUENTES_CONTABLES = [
  { value: 'CB', label: 'Caja/Banco' },
  { value: 'LD', label: 'Libro Diario' },
  { value: 'RC', label: 'Registro de Compras' },
  { value: 'RV', label: 'Registro de Ventas' },
  { value: 'RH', label: 'Recibos por Honorarios' },
  { value: 'PL', label: 'Planilla' },
  { value: 'OT', label: 'Otros' },
];

export const MONEDAS = [
  { value: 'MN', label: 'Moneda Nacional (S/)' },
  { value: 'ME', label: 'Moneda Extranjera (US$)' },
];

export const TIPO_AFECTACION_VENTAS = [
  { value: 'S', label: 'Gravada (con IGV)' },
  { value: 'V', label: 'Valor de Exportación' },
  { value: 'E', label: 'Exonerada' },
  { value: 'I', label: 'Inafecta' },
  { value: 'O', label: 'Otros' },
  { value: 'X', label: 'Sin registro RC/RV' },
];

export const initialVoucher: Partial<Voucher> = {
  idVoucher: 0,
  numeroRegistro: '',
  codigoFuente: 'LD',
  glosa: '',
  monedaOrigen: 'MN',
  tipoCambio: 1,
  estado: 'ACTIVO',
  totalDebeMN: 0,
  totalHaberMN: 0,
  totalDebeME: 0,
  totalHaberME: 0,
  detalles: [],
};

export const initialVoucherDetalle: Partial<VoucherDetalle> = {
  idVoucherDetalle: 0,
  numeroLinea: 0,
  codigoCuenta: '',
  debeMN: 0,
  haberMN: 0,
  debeME: 0,
  haberME: 0,
  codigoAuxiliar: null,
  tipoAuxiliar: null,
  glosaDetalle: null,
  codigoCentroCosto: null,
  codigoArea: null,
};
